var componentRequireContext = require.context("components", true, /front\/youtube\/*/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);